import styled from "styled-components";

export const StyledInput = styled.input.attrs((props) => ({
  className: `${props?.className} input input-bordered border-quartenary rounded bg-white disabled:bg-quartenary disabled:border-quartenary disabled:text-vekin/70 text-vekin-green100 w-full pt-3 px-2 pr-9 h-[3rem] font-normal text-sm focus:outline-none hover:border-vekin-green40 focus:border-vekin placeholder:text-tertiary`,
  readonly: true,
}))``;
